import Layout from '../components/Layout';
import { Container } from '../components/ui/Grid';
import dynamic from 'next/dynamic';
import API from '../api';
import MotionHeader from '@/components/ui/MotionHeader';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import style from '@/components/Geo/geo.module.scss';
import {getServerSidePaths} from "@/pages/contacts/[slug]";

// Заглушка для переводов
const translate = s => s;

const Geo = dynamic(() => import('@/components/Geo'), { ssr: false });

const GeoPage = ({ data }) => (
  <Container>
    {data.title && <MotionHeader className={style.mheader}>{data.title}</MotionHeader>}
    <Geo pageData={data} />
  </Container>
);

const breadcrumbs = [
  { title: translate('Главная'), route: '/' },
  { title: translate('География закупок'), route: '/geo' },
];

GeoPage.getLayout = (page, t) => (
  <Layout
    page={page.props}
    paddings={false}
    customPaddings={style.paddings}
    breadcrumbs={breadcrumbs}
    title={t('География закупок — UNIFROST')}
  >
    {page}
  </Layout>
);

export async function getServerSideProps(context) {
  const props = { data: { map: [] } };

  try {
    const res = await API.get(`/v1/api/pages/geo/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (res.status === 200) {
      if (res.data) props.data = res.data;
    }
  } catch (error) {}

  try {
    const resMap = await API.get(`/v1/api/map/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (resMap.status === 200) {
      if (resMap.data) props.data.map = resMap.data;
    }
  } catch (error) {}

  try {
    const resCategories = await API.get(`/v1/api/products/categories/`, {
      headers: { 'Accept-Language': context.locale },
    });

    if (resCategories.status === 200 && Array.isArray(resCategories.data)) {
      if (resCategories.data) props.data.categories = resCategories.data;
    }
  } catch (error) {}

  return {
    props: {
      ...props,
      ...(await serverSideTranslations(context.locale, ['common', 'menu'])),
    },
    // revalidate: 60,
  };
}

export default GeoPage;
